import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import React from 'react';
import { SxProps } from '@mui/system';
import { Theme } from '@mui/material/styles';

export type SectionGridRowProps = {
  title?: string;
  children: React.ReactNode;
  sx?: SxProps<Theme>;
  hideTopBorder?: boolean;
  'data-testid'?: string;
};

export const SectionGridRow: React.FC<SectionGridRowProps> = ({
  title,
  children,
  sx,
  hideTopBorder,
  'data-testid': testId,
  ...props
}) => {
  return (
    <Grid
      {...props}
      data-testid={testId}
      container
      direction="column"
      sx={{
        pt: 16,
        pl: hideTopBorder ? 0 : 12,
        borderTop: ({ palette }) => (hideTopBorder ? '' : `1px solid ${palette.border}`),
        ...sx,
      }}
    >
      {title && (
        <Grid>
          <Typography variant="h4" data-testid={`${testId}.title`}>
            {title}
          </Typography>
        </Grid>
      )}
      <Grid
        container
        spacing={{ xs: 8, md: 12 }}
        sx={{
          pb: hideTopBorder ? 0 : 12,
          pt: 12,
        }}
      >
        {children}
      </Grid>
    </Grid>
  );
};
